<template>
  <SocialstyrelsenGenericDrugsView :atc="$route.params.atc"
                                   :atc-presentation-string="$route.params.atcPresentation"
                                   :atc-description="$route.params.atcDescription">
  </SocialstyrelsenGenericDrugsView>
</template>

<script>
import SocialstyrelsenGenericDrugsView from '@/components/SocialstyrelsenGenericDrugsView.vue';
import {defineComponent} from "vue";

export default defineComponent({
  name: 'socialstyrelsen-generic-drugs-page',
  components: {
    SocialstyrelsenGenericDrugsView
  }
});
</script>
